import React from "react"
import lodash from "lodash"
import styled from "styled-components"
import { components } from "react-select"

import Field from "components/Field"
import Select from "components/Select"

import i18n from "components/Translation/i18n"

const Wrapper = styled.div``

const Input = props => <components.Input {...props} autoComplete="foo" />

export const options = [
  { label: i18n.t("label_customs_0", "0 - zollpflichtig"), value: "0" },
  { label: i18n.t("label_customs_1", "1 - zollfrei mit Ursprungserklärung"), value: "1" }
]

const PrefereneCodeSelect = props => {
  const {
    includeAll,
    hideLabel,
    multi,
    name = "country",
    validation,
    small,
    direct,
    ...rest
  } = props

  const smallStyles = {
    control: provided => ({
      ...provided,
      height: "31",
      minHeight: "31"
    }),
    valueContainer: provided => ({
      ...provided,
      top: "-10%"
    })
  }

  return (
    <React.Fragment>
      <Field
        label={!hideLabel}
        name={name}
        field={name}
        options={options}
        placeholder={"..."}
        clearable={false}
        searchable
        isMulti={multi}
        {...rest}
        validate={validation}
      >
        <Select
          menuContainerStyle={{ minWidth: "250px" }}
          components={{ Input }}
          // menuPortalTarget={document.body}
          styles={small && smallStyles}
          direct
        />
      </Field>
    </React.Fragment>
  )
}

export default PrefereneCodeSelect

export function parsePreferenceCode(value) {
  return lodash.find(options, o => o.value === value)
}

export function stringifyPreferenceCode(value) {
  return lodash.get(value, "value")
}
